import { GsFormFieldPadding, GsFormSchema } from '../../../components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';

/** Show fields only if separator is enabled */ 
const SHOW_SEPARATOR_IF = {
  args: [
    {
      formControlName: 'showSeparator',
      value: true
    }
  ]
};

export const SPACER_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...ACTIVE_SCHEMA_FIELDS,
    {
      formControlName: 'height',
      label: 'components.spacer.schema.height',
      type: 'number',
      min: 64,
      step: 16,
      isResponsive: true,
      default: {
        default: 128
      }
    },
    {
      formControlName: 'showSeparator',
      label: 'components.spacer.schema.showSeparator',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'separatorThickness',
      label: 'components.spacer.schema.separatorThickness',
      type: 'number',
      min: 1,
      step: 1,
      isResponsive: true,
      default: {
        default: 1
      },
      if: SHOW_SEPARATOR_IF
    },
    {
      formControlName: 'separatorColor',
      label: 'components.spacer.schema.separatorColor',
      type: 'color',
      default: 'dark-shade',
      if: SHOW_SEPARATOR_IF
    },
    {
      formControlName: 'separatorPadding',
      label: 'components.spacer.schema.separatorPadding',
      type: 'padding',
      useTailwindClasses: true,
      isResponsive: true,
      default: {
        default: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      },
      if: SHOW_SEPARATOR_IF
    } as GsFormFieldPadding
  ]
};

